import { render, staticRenderFns } from "./TableDO.vue?vue&type=template&id=0c7d7f56&scoped=true&"
import script from "./TableDO.vue?vue&type=script&lang=js&"
export * from "./TableDO.vue?vue&type=script&lang=js&"
import style0 from "./TableDO.vue?vue&type=style&index=0&id=0c7d7f56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7d7f56",
  null
  
)

export default component.exports